var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 22.5,
    cy: 22.5,
    r: 21.5,
    stroke: "#60C8DD",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M22.5 25.5C24.1569 25.5 25.5 24.1569 25.5 22.5C25.5 20.8431 24.1569 19.5 22.5 19.5C20.8431 19.5 19.5 20.8431 19.5 22.5C19.5 24.1569 20.8431 25.5 22.5 25.5Z",
    fill: "#777777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M32.25 16.5H27L33 21.75V17.25C33 17.1515 32.9806 17.054 32.9429 16.963C32.9052 16.872 32.85 16.7893 32.7803 16.7197C32.7107 16.65 32.628 16.5948 32.537 16.5571C32.446 16.5194 32.3485 16.5 32.25 16.5Z",
    fill: "#777777"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M32.25 28.5C32.3485 28.5 32.446 28.4806 32.537 28.4429C32.628 28.4052 32.7107 28.35 32.7803 28.2803C32.85 28.2107 32.9052 28.128 32.9429 28.037C32.9806 27.946 33 27.8485 33 27.75V23.25L27 28.5H32.25Z",
    fill: "#777777"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12 17.25V21.75L18 16.5H12.75C12.6515 16.5 12.554 16.5194 12.463 16.5571C12.372 16.5948 12.2893 16.65 12.2197 16.7197C12.15 16.7893 12.0948 16.872 12.0571 16.963C12.0194 17.054 12 17.1515 12 17.25Z",
    fill: "#777777"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12 27.75C12 27.8485 12.0194 27.946 12.0571 28.037C12.0948 28.128 12.15 28.2107 12.2197 28.2803C12.2893 28.35 12.372 28.4052 12.463 28.4429C12.554 28.4806 12.6515 28.5 12.75 28.5H18L12 23.25V27.75Z",
    fill: "#777777"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.25 16.5H12.75C12.3358 16.5 12 16.8358 12 17.25V27.75C12 28.1642 12.3358 28.5 12.75 28.5H32.25C32.6642 28.5 33 28.1642 33 27.75V17.25C33 16.8358 32.6642 16.5 32.25 16.5Z",
    stroke: "#777777",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 25.5C24.1569 25.5 25.5 24.1569 25.5 22.5C25.5 20.8431 24.1569 19.5 22.5 19.5C20.8431 19.5 19.5 20.8431 19.5 22.5C19.5 24.1569 20.8431 25.5 22.5 25.5Z",
    stroke: "#777777",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27 16.5L33 21.75",
    stroke: "#777777",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27 28.5L33 23.25",
    stroke: "#777777",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18 16.5L12 21.75",
    stroke: "#777777",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18 28.5L12 23.25",
    stroke: "#777777",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/Money.fe4287a0bd0ed94154a4f06074da73e1.svg";
export { ForwardRef as ReactComponent };